import { render, staticRenderFns } from "./courseForm.vue?vue&type=template&id=7de3cce8"
import script from "./courseForm.vue?vue&type=script&lang=js"
export * from "./courseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports